import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => {
  return mergeStyleSets({
    flowStepButtons: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    buttonGroup: {
      display: 'flex',
      gap: '16px',
      '& > button': {
        flexGrow: 1,
      },
    },
    actionButton: {
      flexGrow: 1,
    },
  });
};
